function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { SET_EVENTS_COLLECTIONS, SET_COLLETION_SCHEMA_LOADING, FETCH_COLLECTION_SCHEMA_SUCCESS, SCHEMA_COMPUTED } from './constants';
export var initialState = {
  collections: [],
  loadingSchemas: [],
  schemas: {}
};
export var eventsReducer = function eventsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_COLLETION_SCHEMA_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingSchemas: action.payload.isLoading ? [].concat(_toConsumableArray(state.loadingSchemas), [action.payload.colletion]) : state.loadingSchemas.filter(function (collection) {
          return collection !== action.payload.colletion;
        })
      });

    case SCHEMA_COMPUTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        schemas: _objectSpread(_objectSpread({}, state.schemas), {}, _defineProperty({}, action.payload.collection, _objectSpread(_objectSpread({}, state.schemas[action.payload.collection]), action.payload.schema)))
      });

    case FETCH_COLLECTION_SCHEMA_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        schemas: _objectSpread(_objectSpread({}, state.schemas), {}, _defineProperty({}, action.payload.collection, _objectSpread(_objectSpread({}, state.schemas[action.payload.collection]), {}, {
          schema: action.payload.schema,
          tree: {},
          list: {}
        })))
      });

    case SET_EVENTS_COLLECTIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        collections: action.payload.collections
      });

    default:
      return state;
  }
};